import { render, staticRenderFns } from "./modal-confirmation.vue?vue&type=template&id=0963ac28&"
import script from "./modal-confirmation.vue?vue&type=script&lang=js&"
export * from "./modal-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports